
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { useContext } from "react";
import { Box, Text } from "rebass/styled-components";
import useTranslation from "next-translate/useTranslation";

import Layout from "../components/Layout";
import HeroLanding from "../components/landings/HeroLanding";
import TextWithImg from "../components/TextWithImg";
import FeaturedIn from "../components/home/FeaturedIn";
import OptionsGrid, {
  OptionsTileProps
} from "../components/common/OptionsGrid";
import { LocaleContext } from "../components/locale";
import AboutNumbersGrid from "../components/about/AboutNumbersGrid";
import { pushRoute } from "../lib/routing";
import { useIsMobile, withDeviceType } from "../lib/media";
import { UserType } from "../enums";

interface Props {
  deviceType?: string;
}

function About(props: Props) {
  const { deviceType } = props;
  const { t } = useTranslation("about");

  const isMobileViewport = useIsMobile(deviceType);
  const { country: countryCtx } = useContext(LocaleContext) || {};

  // Images
  const imgCover = "/images/landings/aboutus_header_desktop.jpg";
  const imgWhy = "/images/landings/aboutus_why.jpg";
  let imgOurBeginning = "/images/about/aboutus_es.webp";

  let imgName = "";
  if (countryCtx) {
    if (["dk", "no", "se"].includes(countryCtx)) {
      imgName = "nord";
    } else if (["de", "fr"].includes(countryCtx)) {
      imgName = "fr_de";
    } else {
      imgName = countryCtx;
    }
    imgOurBeginning = "/images/about/aboutus_" + imgName + ".webp";
  }

  // Options Grid
  const findSitter = () => {
    pushRoute({ pathname: "/search" });
  };

  const becomeSitter = () => {
    pushRoute({
      pathname: "/signup",
      search: { type: UserType.CAREGIVER }
    });
  };

  const iconsOptions = ["dog-whiskers", "user"];
  const btnActions = [findSitter, becomeSitter];
  const itemsOptions = [...Array(2)].map((_, i) => {
    return {
      icon: iconsOptions[i],
      title: t(`optionsTitle${i + 1}`),
      btnText:
        i === 1 && isMobileViewport ? t("start") : t(`optionsBtn${i + 1}`),
      btnAction: btnActions[i]
    };
  }) as OptionsTileProps[];

  return (
    <Layout withTransparentHeader title={t("pageName")}>
      <HeroLanding
        isMobileViewport={isMobileViewport}
        imgsrc={imgCover}
        imgAlt={t("pageName")}
        title={t("title")}
      />

      {!isMobileViewport && <Box height={32} />}

      <TextWithImg
        title={t("ourBeginningTitle")}
        imgsrc={imgOurBeginning}
        imgAlt={t("ourBeginningTitle")}
        imgRight={isMobileViewport}
        height={["inherit", "inherit", 390]}
      >
        <Text as="p" variant={"textWithImg.text"}>
          {t("ourBeginningDesc")}
        </Text>
      </TextWithImg>

      <AboutNumbersGrid />

      <TextWithImg
        title={t("whyTitle")}
        imgsrc={imgWhy}
        imgAlt={t("whyTitle")}
        imgRight
      >
        <Text as="p" variant={"textWithImg.text"}>
          {t("whyDesc")}
        </Text>
      </TextWithImg>

      <FeaturedIn showTitle={false} />

      <OptionsGrid title={t("optionsTitle")} items={itemsOptions} />

      {!isMobileViewport && <Box height={32} />}
    </Layout>
  );
}

 const _getServerSideProps = withDeviceType()();

export default About;


// @ts-ignore
    export async function getServerSideProps(ctx) {
// @ts-ignore
        let res = _getServerSideProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/about',
// @ts-ignore
              loaderName: 'getServerSideProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  